import { ChangeDetectionStrategy, Component, computed, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';

import { AuthService } from '../../services/auth.service';

interface NavItem {
  path: string;
  label: string;
  /** Material Icons ligature name (например, 'event', 'group', 'shield'). */
  icon: string;
}

@Component({
  selector: 'admin-shell',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, RouterLink, RouterLinkActive, RouterOutlet, MatIconModule],
  templateUrl: './shell.component.html',
  styleUrls: ['./shell.component.scss'],
})
export class ShellComponent {
  private readonly auth = inject(AuthService);

  readonly currentUser = computed(() => this.auth.getCurrentUser());
  readonly menuOpen = signal(false);

  readonly navItems: NavItem[] = [
    { path: '/admins', label: 'Админы', icon: 'shield' },
    { path: '/users', label: 'Пользователи', icon: 'group' },
    { path: '/events', label: 'Мероприятия', icon: 'event' },
  ];

  toggleMenu(): void {
    this.menuOpen.update((v) => !v);
  }

  closeMenu(): void {
    this.menuOpen.set(false);
  }

  logout(): void {
    this.auth.logout();
  }
}
